import { render, staticRenderFns } from "./InviteJoinLogin.vue?vue&type=template&id=328dddde&scoped=true"
import script from "./InviteJoinLogin.vue?vue&type=script&lang=js"
export * from "./InviteJoinLogin.vue?vue&type=script&lang=js"
import style0 from "./InviteJoinLogin.vue?vue&type=style&index=0&id=328dddde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328dddde",
  null
  
)

export default component.exports